import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledVisitTemplateReadOnlyField = styled(StyledFlex)`
   height: 180px;
   overflow: hidden;
`;
